import React, { useState } from 'react';
import { MessageCircle, X, Instagram, Send } from 'lucide-react';

const FloatingChatButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const instagramUsername = 'itsfarzeenkhan';
  const instagramDMLink = `https://ig.me/m/${instagramUsername}`;

  return (
    <>
      {/* Chat Popup */}
      {isOpen && (
        <div 
          className="fixed bottom-24 right-6 z-50 w-80 rounded-2xl shadow-2xl overflow-hidden animate-slideUp"
          style={{ backgroundColor: '#ffffff' }}
        >
          {/* Header */}
          <div 
            className="p-4 flex items-center justify-between"
            style={{ 
              background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #F77737 100%)'
            }}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <Instagram className="text-white" size={20} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">Let's Chat!</p>
                <p className="text-white/80 text-xs">@{instagramUsername}</p>
              </div>
            </div>
            <button 
              onClick={() => setIsOpen(false)}
              className="text-white/80 hover:text-white transition-colors"
            >
              <X size={20} />
            </button>
          </div>
          
          {/* Body */}
          <div className="p-5">
            <div className="mb-4">
              <div 
                className="inline-block p-3 rounded-2xl rounded-tl-sm max-w-[85%]"
                style={{ backgroundColor: '#f1f5f9' }}
              >
                <p className="text-sm" style={{ color: '#333' }}>
                  Hey! 👋 I'm Farzeen. Got questions about digital marketing or my programs? 
                </p>
              </div>
            </div>
            <div className="mb-4">
              <div 
                className="inline-block p-3 rounded-2xl rounded-tl-sm max-w-[85%]"
                style={{ backgroundColor: '#f1f5f9' }}
              >
                <p className="text-sm" style={{ color: '#333' }}>
                  Send me a DM on Instagram - I personally reply to every message! 💬
                </p>
              </div>
            </div>
            
            {/* CTA Button */}
            <a 
              href={instagramDMLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-xl font-medium text-white transition-all hover:scale-[1.02] hover:shadow-lg"
              style={{ 
                background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #F77737 100%)'
              }}
            >
              <Send size={18} />
              Open Instagram DM
            </a>
            
            <p className="text-center text-xs mt-3" style={{ color: '#999' }}>
              I usually respond within a few hours ✨
            </p>
          </div>
        </div>
      )}

      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
        style={{ 
          background: 'linear-gradient(135deg, #833AB4 0%, #FD1D1D 50%, #F77737 100%)'
        }}
      >
        {isOpen ? (
          <X className="text-white" size={24} />
        ) : (
          <>
            <MessageCircle className="text-white" size={24} />
            {/* Pulse animation */}
            <span className="absolute w-full h-full rounded-full animate-ping opacity-30" style={{ backgroundColor: '#FD1D1D' }}></span>
          </>
        )}
        
        {/* Tooltip */}
        {!isOpen && (
          <span className="absolute right-16 bg-white px-3 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: '#333' }}>
            Let's Chat! 💬
          </span>
        )}
      </button>

      {/* Animation styles */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out forwards;
        }
      `}</style>
    </>
  );
};

export default FloatingChatButton;
